module.exports = __webpack_public_path__ + "img/logo-primary.2c99a0a4.png";